export enum ActivityLogSourceType {
  // https://github.com/customerio/services/blob/f0eac71e70c3c2079cc5ebb931eaa4b6208bc4b1/inboundmail/unsubscribe.go#L87
  ListUnsubscribe = 'mx-unsubscribe.customer.io',
  // anything coming in through the track APIs
  TrackAPI = 'track.customer.io',
  TrackEUAPI = 'track-eu.customer.io',
  // https://github.com/customerio/services/blob/f0eac71e70c3c2079cc5ebb931eaa4b6208bc4b1/cmds/subscription_center/server.go#L238
  Subscriptions = 'subscriptions.customer.io',
  // attribute update action
  // https://github.com/customerio/services/blob/f0eac71e70c3c2079cc5ebb931eaa4b6208bc4b1/campaigns/campaign_runtime/render_attribute_update.go#L188
  AttributeUpdateAction = 'attribute_update_action',
  // query collection attribute update
  // https://github.com/customerio/services/blob/f0eac71e70c3c2079cc5ebb931eaa4b6208bc4b1/collections/collections_runtime/query.go#L204
  QueryCollection = 'query_collection',
  // webhook response attribute update
  // https://github.com/customerio/services/blob/f0eac71e70c3c2079cc5ebb931eaa4b6208bc4b1/deliveries/jobs/send_webhook.go#L489
  Webhook = 'webhook',
  // manual changes from the UI, like deleting profiles or editing attributes
  UI = 'ui',
  // events sent from the UI
  // https://github.com/customerio/services/blob/main/ui_api/events/send.go#L124
  UIEvent = 'ui_event',
  // people imports
  // https://github.com/customerio/services/blob/f0eac71e70c3c2079cc5ebb931eaa4b6208bc4b1/imports/imports_runtime/process.go#L209
  Import = 'import',
  // https://github.com/customerio/services/blob/main/edge_api/serve_grpc/custom_form_submission.go#L274
  // https://github.com/customerio/services/blob/main/edge_api/serve_grpc/facebook_webhook.go#L52
  FormIntegration = 'form_integration',
  SQLImport = 'sql_import',
  // https://github.com/customerio/services/blob/main/edge_api/serve_grpc/merge.go#L65
  // https://github.com/customerio/services/blob/main/merge/merge.go#L196
  // https://github.com/customerio/services/blob/main/ui_api/customers/merge.go#L42
  ProfileMerge = 'profile merge',
  Action = 'action',
  //  https://github.com/customerio/services/blob/689c4c27c167587d8276ca9d1a0255f8d2d226a8/core/batch/batch.go#L1266
  Newsletter = 'newsletter',
  // https://github.com/customerio/services/blob/689c4c27c167587d8276ca9d1a0255f8d2d226a8/core/batch/batch.go#L1274
  Transactional = 'transactional',
  // system-generated changes (i.e. migrations, backfills, etc.)
  System = 'system',
  // https://github.com/customerio/services/blob/b389b7d7a91f89eebb2092b5e97978f0d83a2b19/core/batch/deliveries.go#L656
  // https://github.com/customerio/services/blob/b389b7d7a91f89eebb2092b5e97978f0d83a2b19/core/events/log.go#L23
  SystemAutomaticDeletion = 'system_auto_delete',
  ObjectCampaignsAudience = 'object_campaigns_audience',
}

export enum ActivityLogSourceSubType {
  AutoMerge = 'auto_merge',
}
